// extracted by mini-css-extract-plugin
module.exports = {"var-xxl":"1360px","varXxl":"1360px"};